<template>
  <div class="input-wrapper">
    <div class="input-boolean">
      <template v-if="data.Icon && data.Icon.includes('fa-thumbs-up')">
        <div class="left">
          <button type="button" class="input-yes" :class="{ active: inputVal === 'true' || inputVal === true }" @click="onYes">
            <icon
              :icon="['fad', 'thumbs-up']"
              :style="{
                '--fa-primary-color': '#4b6daa',
                '--fa-secondary-color': '#fbce9d',
                '--fa-primary-opacity': '1',
                '--fa-secondary-opacity': '1'
              }"
              size="3x"
            ></icon>
          </button>
          <h4 class="label">{{ labelYes }}</h4>
        </div>
        <div class="right">
          <button type="button" class="input-no" :class="{ active: inputVal === 'false' || inputVal === false }" @click="onNo">
            <icon
              :icon="['fad', 'thumbs-down']"
              :style="{
                '--fa-primary-color': '#4b6daa',
                '--fa-secondary-color': '#fbce9d',
                '--fa-primary-opacity': '1',
                '--fa-secondary-opacity': '1'
              }"
              size="3x"
            ></icon>
          </button>
          <h4 class="label">{{ labelNo }}</h4>
        </div>
        <div class="input-checkbox hidden">
          <input
            :id="inputData.name"
            :name="inputData.name"
            :required="inputData.required"
            type="checkbox"
            class="input-boolean"
            v-model="inputVal"
            @change="onChange"
            @focus="onFocus"
            @blur="onBlur"
          />
          <label :for="inputData.name" v-if="data.Text" :title="data.Text">{{
            data.Text
          }}</label>
        </div>
      </template>
      <template v-else-if="data.Icon && data.Icon.includes('fa-envelope')">
        <button type="button" @click="onToggle">
          <icon
            :icon="['fad', 'envelope']"
            :style="{
              '--fa-primary-color': '#4b6daa',
              '--fa-secondary-color': '#fbce9d',
              '--fa-primary-opacity': '1',
              '--fa-secondary-opacity': '1'
            }"
            size="3x"
          ></icon>
          {{ data.Text }}
        </button>
        <div class="input-checkbox hidden">
          <input
            :id="inputData.name"
            :name="inputData.name"
            :required="inputData.required"
            type="checkbox"
            class="input-boolean"
            v-model="inputVal"
            @change="onChange"
            @focus="onFocus"
            @blur="onBlur"
          />
          <label :for="inputData.name" v-if="data.Text" :title="data.Text">{{
            data.Text
          }}</label>
        </div>
      </template>
      <template v-else>
        <label class="wrap" :for="inputData.name" v-if="data.Text" :title="data.Text">{{
          data.Text
        }}</label>
        <label class="toggle-switch">
          <input
            :id="inputData.name"
            :name="inputData.name"
            :required="inputData.required"
            type="checkbox"
            class="input-boolean"
            v-model="inputVal"
            @change="onChange"
            @focus="onFocus"
            @blur="onBlur"
          />
          <span class="toggle-slider">
            <span class="toggle-title">{{title}}</span>
          </span>
        </label>
      </template>
    </div>
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

export default {
  name: 'InputBoolean',
  components: {},
  props: {
    value: {
      default: null
    },
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String,
    labelYes: {
      type: String,
      default: 'Yes'
    },
    labelNo: {
      type: String,
      default: 'No'
    },
    callbackYes: {
      type: Function,
      default: function() {
        console.log('Button clicked (default for "Yes").')
        return 'true'
      }
    },
    callbackNo: {
      type: Function,
      default: function() {
        console.log('Button clicked (default for "No").')
        return 'false'
      }
    }
  },
  data: () => {
    return {
      isFocused: false,
      inputData: {
        value: '',
        type: false,
        name: '',
        required: false
      }
    }
  },
  computed: {
    inputVal: {
      get: function() {
        if (this.value === '' || this.value === null || this.value === undefined)
          return null
        if (this.value === true || this.value === 'true')
          return true
        return false
      },
      set: function(val) {
        this.$emit('input', val)
      }
    },
    title: function () {
      if (this.inputVal)
        return 'Yes'
      return 'No'
    }
  },
  methods: {
    alert: function(msg) {
      this.$store.commit('openToast', {
        text: msg,
        type: 'warning'
      })
    },
    validate: function(alert) {
      alert = alert === true ? true : false
      this.$emit('input:value', this.inputVal)
      this.inputData.value = this.inputVal
      const parsedValue = PreApproveMe.parseInputValue(this.inputData)
      this.$emit('input:value-parsed', parsedValue)
      if (true) {
        this.$emit('input:isvalid', true)
      } else {
        this.$emit('input:isvalid', false)
        if (alert) {
          this.alert('You must agree to continue')
        }
      }
    },
    formValidate: function() {
      if (
        this.$store.getters.getSection(this.sectionid) != null &&
        this.$store.getters.getPage(this.pageid) != null
      )
        this.validate(false) // Change to true to alert
    },
    onChange: function() {},
    onFocus: function() {
      this.isFocused = true
      this.$emit('input:isfocused', true)
    },
    onBlur: function() {
      this.validate()
      this.isFocused = false
      this.$emit('input:isfocused', false)
    },
    onToggle: function() {
      if (this.inputVal === true || this.inputVal === 'true')
        this.inputVal = this.callbackNo()
      else this.inputVal = this.callbackYes()
      this.validate()
    },
    onYes: function() {
      this.inputVal = this.callbackYes()
    },
    onNo: function() {
      this.inputVal = this.callbackNo()
    }
  },
  created: function() {
    if (this.data.Type) this.inputData.type = this.data.Type
    else this.inputData.type = PreApproveMe.getInputType('Agreements') // ?
    this.inputData.name = this.data.Id
    this.inputData.required = this.data.Required
    // if (this.data.Value) {
    //   this.inputVal = this.data.Value
    //   this.validate()
    // } else if (typeof this.value !== 'undefined') {
    //   this.inputVal = this.value
    // }
    // Validate if pre-filled

    this.inputVal = this.data.Value
    if (this.value) {
      this.validate()
    }

    this.$root.$on('form:validate', this.formValidate)
    this.$root.$on('form:validate-force', this.validate)
  },
  watch: {
    inputVal: function(value) {
      this.$emit('input:change', value)
      this.validate()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.input-wrapper {
  &.container {
    width: $screen-container-width;
    // width: 100%;
  }
  .input-boolean {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 1rem 0;
    > .left,
    > .right {
      display: inline-block;
      width: 49%;
    }
    > .left {
      margin-right: 2%;
    }
    h4.label {
      display: block;
      width: 100%;
      margin: 0.5rem 0 0 0;
      text-align: center;
    }
    button {
      padding: 1rem 0;
      width: 100%;
      background-color: $white;
      border-radius: 6px;
      box-shadow: 0 0 2px 2px rgba(155, 155, 155, 0.2);
      color: $dark;
      .svg-inline--fa {
        margin: 0 1rem;
      }
    }
    label {
      &.wrap {
        width: calc(100% - 100px);
        white-space: normal;
      }
    }

    .wrap {
      font-size: 14px;
      text-transform: unset;
    }

    .toggle-switch {
      float: right;
      position: relative;
      width: 62px;
      height: 24px;
      > .toggle-slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 24px;
        &:before {
          position: absolute;
          content: '';
          height: 20px;
          width: 20px;
          left: 2px;
          bottom: 2px;
          background-color: white;
          -webkit-transition: 0.4s;
          transition: 0.4s;
          border-radius: 50%;
        }
        .toggle-title {
          position: absolute;
          font-size: 16px;
          color: white;
          top: 6px;
          left: 28px;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }
      }
      > input {
        opacity: 0;
        width: 0;
        height: 0;
        &:checked + .toggle-slider {
          background-color: #2196f3;
          .toggle-title {
            left: 6px;
          }
        }
        &:focus + .toggle-slider {
          box-shadow: 0 0 1px #2196f3;
        }
        &:checked + .toggle-slider:before {
          -webkit-transform: translateX(38px);
          -ms-transform: translateX(38px);
          transform: translateX(38px);
        }
      }
    }
    .input-checkbox {
      &.hidden {
        display: none;
      }
    }

    .active {
      background-color: #e6e6e6;
      border-color: #c2cbd2;
    }
  }
}
</style>
